module.exports = __webpack_public_path__ + "img/Share.b36f4cbd.gif";